import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_DATABASE_PERFORMANCE_INSIGHT,
  GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_SUCCESS,
  GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureDatabasePerformanceInsightList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureDatabasePerformanceInsightStore(
  state = initialState,
  action
) {
  switch (action.type) {
    case GET_AZURE_DATABASE_PERFORMANCE_INSIGHT:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureDatabasePerformanceInsightList: action.data,
        error: null,
      };
    case GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
